import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useHistory } from "react-router-dom";
import { ChevronRight, Headphones } from "lucide-react";
import * as LucideIcons from "lucide-react";
import { addNewStyle, API, CRISTP_ID, wait } from 'utils/Helper';
import "../components/Layout/sidebarHello.css";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { TbWorld } from "react-icons/tb";
import storage from "utils/Storage";

import { useActiveGroups } from "hooks/useGameEngine";
import { useSiteSettingsQuery } from "hooks/useAuth";

const SupportButton = styled.button`
  display: flex;
  align-items: center;
  background-color: #27272a;
  border: none;
  width: 200px;
  border-radius: 20px;
  padding-right: 20px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2a2a2a;
  }
`;

const SupportItemButton = styled.button`
  display: flex;
  align-items: center;
  color: white;
  justify-content: ${(props) =>
    props.isCollapsed ? "center" : "left "}!important;
  padding: ${(props) => (props.isCollapsed ? "2px" : "2px 8px")};
  cursor: pointer;
  position: relative;
  margin-top: 8px;
  margin: ${(props) => (props.isCollapsed ? "3px" : "5px 7px")};
  border-radius: 5px;
  background-color: #323738 !important;
  width: 93%;
  border: none;
  text-decoration: none;
  font-weight: normal;
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(
      to left,
      #323738,
      #376350
    ) !important;
  }

  ${(props) =>
    props.isCollapsed &&
    `
        justify-content: center;
        padding: 8px 0;
      `}
`;

const IconWrapperSupport = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #57d219;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;
const IconWrapperTelegram = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #24A1DE;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 12px;
`;

const Text = styled.span`
  color: white;
  font-size: 14px;
  font-weight: 500;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  margin: 0px 12px;
`;

const Title = styled.div`
  color: #9ca3af;
  font-size: 14px;
  margin-left: 10px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3c4142;
  color: white;
  padding: 10px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: linear-gradient(
      to left,
      #323738,
      #376350
    ); /* Apply hover effect here */
  }
`;

const ButtonText = styled.span`
    font-size: 14px;
    display: ${(props) => (props.isCollapsed ? "none" : "block")};
   
  }
  `;

const StyledChevronRight = styled(ChevronRight)`
  color: #9ca3af;
  display: ${(props) => (props.isCollapsed ? "none" : "block")};
`;

const SidebarContainer = styled.nav`
  color: rgba(153, 164, 176, 0.8);
  background-color: #292d2e;
  transition: 0.2s linear;
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  height: 100vh;
  padding: ${(props) => (props.isCollapsed ? "12px 0px" : "12px 0px")};
  color: #ffffff;
  position: fixed;
  top: -12px;
  left: 0;
  z-index: 999;
  transition: width 0.3s ease;
  overflow-y: auto;

  @media (max-width: 768px) {
    display: ${(props) => (props.isCollapsedMobile ? "block" : "none")};
    width: 80% !important;
  }
`;

const SidebarTop = styled.div`
  background-color: #292d2e;
  width: ${(props) => (props.isCollapsed ? "86px" : "242px")};
  padding: ${(props) => (props.isCollapsed ? "20px" : "9px")};
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  display: flex;
  transition: width 0.3s ease, padding 0.3s ease;

  position: fixed;
  top: 0px;
  z-index: 9999;

  @media (max-width: 768px) {
    display: ${(props) => (props.isCollapsedMobile ? "flex" : "none")};
    width: 80% !important;
  }
`;

const Backdrop = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(2px);
    z-index: 998;
  }
`;

const CircularBarContainer = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 5px;
  // background-color: rgb(26, 28, 32);
  background-color: #3a4142;
  box-shadow: transparent 0px 2px 4px 0px;
  z-index: 9999;
  position: absolute;
  top: 12px;
  padding: 5px;
  left: 18px;
  transition: right 0.2s linear;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white !important;
  font-size: 20px;
`;

const MenuItemLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${(props) => (props.color ? "white" : "white")};
  justify-content: center;
  justify-content: ${(props) =>
    props.isCollapsed ? "center" : "left "}!important;
  padding: ${(props) => (props.isCollapsed ? "2px" : "2px 8px")};
  cursor: pointer;
  position: relative;
  margin-top: 8px;
  // border:1px solid green;
  margin: ${(props) => (props.isCollapsed ? "3px" : "5px 7px")};
  border-radius: 5px;
  // background-color:#3c4142;
  background-color: #323738 !important;
  width: 93%;
  // border-top-right-radius: 20px;
  // border-bottom-right-radius: 20px;
  text-decoration: none;
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};
  transition: background 0.2s ease, transform 0.1s ease;

  &:hover {
    background: linear-gradient(
      to left,
      #323738,
      #376350
    ); /* Apply hover effect here */
  }
  ${(props) =>
    !props.isCollapsed &&
    props.active &&
    `
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          color:white;
          // border:1px solid green;
          border-radius:5px;
          // margin:0px 5px;
          background: linear-gradient(to left, #323738, #376350);
          // background-color: rgba(76,175,80,0.2);
          // border-top-right-radius: 20px;
          // border-bottom-right-radius: 20px;

        }
      `}

  ${(props) =>
    props.isCollapsed &&
    `
        justify-content: center;
        padding: 8px 0;
        color:white;
        
      `}
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.isCollapsed ? "0" : "3px")};
  position: relative;
  z-index: 1;

  ${(props) =>
    props.isCollapsed &&
    props.active &&
    `
        background-color: #2E3238;
        border-radius: 50%;
        width: 50px;
        height: 50px;
      `}
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const Label = styled.span`
  font-size: ${(props) => (props.isVIP || props.isPromotion ? "16px" : "14px")};
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) =>
    props.isVIP || props.isPromotion ? "italic" : "normal"};
  position: relative;
  z-index: 1;

  color: ${(props) => {
    if (props.isVIP) return "#EB5D0E";
    if (props.isPromotion) return "#5DDB1B";
    return "#808A94";
  }} !important;
  display: ${(props) => (props.isCollapsed ? "none" : "inline")};
`;

const Divider = styled.div`
  height: 1px;
  background-color: #353535;
  margin: 8px ${(props) => (props.isCollapsed ? "4px" : "16px")};
`;

const SwitcherContainer = styled.div`
  display: ${(props) => (props.isCollapsed ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-left: 50px;

  @media (max-width: 768px) {
    padding-left: 45px;
  }
`;

const Tab = styled.div`
  width: 100%;

  // padding: 8px 28px;
  // border-radius: 9999px;
  // font-size: 14px;
  // font-weight: 500;
  // transition: background-color 0.3s, color 0.3s;
`;

const DropdownMenu = styled.div`
  align-items: center;
  color: white;
  padding: 2px 8px;
  cursor: pointer;
  position: relative;
  // margin-top: 8px;
  margin: 5px 7px;
  border-radius: 5px;
  // background-color: #3c4142;
  width: 93%;

  // border:1px solid brown;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  text-align: center;
  justify-content: center;
  padding: 2px 0px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  // background-color: #3a4142;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-top: -7px;
  // margin-left: 10px;
  // margin-right: 10px
  font-weight: ${(props) =>
    props.isVIP || props.isPromotion ? "bold" : "normal"};
  font-style: ${(props) => (props.isVIP ? "italic" : "normal")};
`;

const DropdownItem = styled(Link)`
  display: block;
  color: white;
  padding: 15px 12px;
  textalign: center;
  text-decoration: none;
  border-radius: 5px;
  background-color: #3c4142;
  margin-top: 10px;

  &:hover {
    background: linear-gradient(to left, #323738, #376350);
  }
`;

const TabContainer = styled.div`
  display: ${(props) => (props.isCollapsed ? "none" : "flex")};
  justify-content: space-between;
  margin: 18px 16px 18px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 2px;
  position: relative;
`;

const SidebarTab = styled.div`
  flex: 1;
  padding: 8px 4px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  text-align: center;
  transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${props => props.active ? '#1fc16b' : '#9CA3AF'};
  position: relative;
  z-index: 2;

  &:hover {
    color: ${props => props.active ? '#1fc16b' : '#ffffff'};
  }
`;

const SlidingIndicator = styled.div`
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 33.33%;
  height: 2.5px;
  background-color: #1fc16b;
  border-radius: 2px;
  box-shadow: 0 1px 6px rgba(31, 193, 107, 0.5);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(${props => props.activeIndex * 100}%);
  z-index: 1;
`;

const AnimatedListWrapper = styled.div`
  animation: fadeIn 0.35s ease-out;
  @keyframes fadeIn {
    from {
      opacity: 0.7;
      transform: translateY(2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SidebarContent = styled.div`
  margin-top: 70px;
  @media (max-width: 768px) {
    margin-top: 64px;
  }
`;


const SidebarHello = ({ isCollapsed, setIsCollapsed, isCollapsedMobile, setIsCollapsedMobile, isSmallScreen }) => {
  const location = useLocation();
  const history = useHistory();
  const isCasino = location.pathname.startsWith('/casino');
  const isSports = location.pathname.startsWith('/sports');
  const activeTab = isCasino ? 'Casino' : (isSports ? 'Sports' : 'Home');
  const tabs = ["Home", "Casino", "Sports"];
  const isAuthed = !!localStorage.getItem("logged") || !!storage.getKey('logged');
  const { data: groupsData } = useActiveGroups();
  const groups = groupsData || [];
  const [lotteryDropdownOpen, setLotteryDropdownOpen] = useState(false); // State to control dropdown

  const { data: settingsData } = useSiteSettingsQuery();
  const settings = settingsData?.data?.[0] || {};

  const [loaded, setLoaded] = useState(false);

  const support = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;

    if (!loaded) {
      console.log("support");
      setLoaded(true);
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      document.head.appendChild(script);
    }

    addNewStyle("#crisp-chatbox {display:block !important;}");
    addNewStyle(
      ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
    );

    wait(2000).then(() => {
      const close = document.querySelector(".cc-wdhl");
      if (close === null) return;
      close.addEventListener("click", function (event) {
        addNewStyle("#crisp-chatbox {display:none !important;}");
        document.getElementById("chtt").src = "";
      });
    });
  };


  useEffect(() => {
    const toggleValue = localStorage.getItem("isCollapsed");
    if (toggleValue !== null) {
      setIsCollapsed(toggleValue === "true");
    }
  }, []);


  function telegramLink() {
    // console.log(settings)
    window.location.href = settings?.telegram_link
  }

  function whatsappLink() {
    const phoneNumber = settings?.whatsapp_no?.replace(/[^\d]/g, ''); // remove any symbols like +, -, spaces
    const message = encodeURIComponent("Hello! I need help."); // optional
    if (phoneNumber) {
      window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    } else {
      console.error("WhatsApp number not found in settings");
    }
  }

  const toggleSidebar = () => {
    const newIsCollapsed = !isCollapsed;
    setIsCollapsed(newIsCollapsed);
    localStorage.setItem("isCollapsed", newIsCollapsed.toString());
  };



  const handleItemClick = () => {
    if (window.innerWidth <= 768) {
      if (setIsCollapsedMobile) setIsCollapsedMobile(false);
      const aside = document.querySelector('aside');
      if (aside) aside.style.transform = 'translateX(-100%)';
    }
  };

  const handleTabClick = (tab) => {
    if (tab === 'Casino') history.push('/casino');
    else if (tab === 'Sports') history.push('/sports');
    else history.push('/');

    if (window.innerWidth <= 768) {
      if (setIsCollapsedMobile) setIsCollapsedMobile(false);
      const aside = document.querySelector('aside');
      if (aside) aside.style.transform = 'translateX(-100%)';
    }
  };

  const CASINO_ITEMS = [
    { name: 'Home', icon: window?.siteConfig?.logo_small ? (API + window.siteConfig.logo_small) : null, path: '/casino' }
  ];

  const HOME_ITEMS = [
    { name: 'Home', icon: window?.siteConfig?.logo_small ? (API + window.siteConfig.logo_small) : null, path: '/' }
  ];

  const SPORTS_ITEMS = [
    { name: 'Home', icon: window?.siteConfig?.logo_small ? (API + window.siteConfig.logo_small) : null, path: '/sports' }
  ];

  const COMMON_ITEMS = [
    { name: 'Affiliate', icon: '/assets/bcimages/sidebar/affiliate.svg', path: '/affiliate' },
    { name: 'VIP Club', icon: '/assets/bcimages/sidebar/vip.svg', color: 'rgb(235, 93, 15)', path: '/vip-club' },
    { name: 'Promotions', icon: '/assets/bcimages/sidebar/promotion.svg', color: 'rgb(93, 219, 28)', path: '/promotions' },
    { name: 'Missions', icon: 'Target', path: '/missions' },
    { name: 'Offers', icon: 'Tag', path: '/offers' },
    { divider: true },
    { name: 'Rewards', icon: '/assets/bcimages/sidebar/Lottery.svg', path: '/rewards', authRequired: true },
    { name: 'Provably Fair', icon: '/assets/bcimages/sidebar/probablyfair.svg', color: 'rgb(235, 93, 15)', path: '/provably-fair' }
  ];

  let currentStaticItems = [];
  let dynamicGroups = [];
  let dynamicGroupPrefix = '';

  if (activeTab === 'Home') {
    currentStaticItems = HOME_ITEMS;
    dynamicGroups = groups.filter(g => g.show_on_home_index);
    dynamicGroupPrefix = '/group/';
  } else if (activeTab === 'Casino') {
    currentStaticItems = CASINO_ITEMS;
    dynamicGroups = groups.filter(g => g.show_as_tab_casino);
    dynamicGroupPrefix = '/casino/group/';
  } else if (activeTab === 'Sports') {
    currentStaticItems = SPORTS_ITEMS;
    dynamicGroups = groups.filter(g => g.show_as_tab_sports);
    dynamicGroupPrefix = '/sports/group/';
  }

  const renderDesktopItem = (item, index, prefix = '') => {
    if (item.authRequired && !isAuthed) return null;

    if (item.divider) {
      return <Divider key={`divider-${prefix}-${index}`} isCollapsed={finalIsCollapsed} />;
    }
    return (
      <MenuItemLink
        key={item.name}
        to={item.path}
        active={location.pathname === item.path}
        color={item.color}
        isCollapsed={finalIsCollapsed}
        onClick={handleItemClick}
        style={{
          backgroundColor: location.pathname === item.path ? "#333" : "transparent",
        }}
      >
        <IconWrapper
          active={location.pathname === item.path}
          isCollapsed={finalIsCollapsed}
        >
          {typeof item.icon === 'string' && LucideIcons[item.icon] ? (
            React.createElement(LucideIcons[item.icon], {
              size: 20,
              style: { color: "white", width: "20px", height: "20px" }
            })
          ) : (
            <Icon
              src={item.icon ? (item.icon.startsWith('/uploads/') ? (API + item.icon) : item.icon) : 'https://static.nanogames.io/assets/slots.42749df8.png'}
              alt={item.name}
              style={{ width: "25px", height: "25px", objectFit: "contain" }}
            />
          )}
        </IconWrapper>
        <Label
          active={location.pathname === item.path}
          isCollapsed={finalIsCollapsed}
        >
          <span
            className="game-fonts"
            style={{
              color: "white",
              fontSize: "13px",
              fontWeight: "bold",
            }}
          >
            {item.name}
          </span>
        </Label>
      </MenuItemLink>
    );
  };

  const finalIsCollapsed = isSmallScreen ? false : isCollapsed;
  return (
    <>
      {isCollapsedMobile && (
        <Backdrop onClick={() => setIsCollapsedMobile(false)} />
      )}
      <SidebarContainer isCollapsed={finalIsCollapsed} isCollapsedMobile={isCollapsedMobile}>
        <SidebarTop isCollapsed={finalIsCollapsed} isCollapsedMobile={isCollapsedMobile}>
          <CircularBarContainer onClick={() => isSmallScreen ? setIsCollapsedMobile(false) : toggleSidebar()}>
            <LucideIcons.Menu size={20} color="white" />
          </CircularBarContainer>

          <SwitcherContainer style={{ margin: "4px" }} isCollapsed={finalIsCollapsed}>
            <div className="bc-logo" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <img
                src={window?.siteConfig?.logo_big ? (API + window.siteConfig.logo_big) : "/assets/images/logo.png"}
                style={{ width: "100px", maxWidth: "100%", height: "auto", objectFit: "contain" }}
                alt="logo"
              />
            </div>
          </SwitcherContainer>
        </SidebarTop>
        <SidebarContent>
          <TabContainer isCollapsed={finalIsCollapsed}>
            {tabs.map(tab => (
              <SidebarTab
                key={tab}
                active={activeTab === tab}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </SidebarTab>
            ))}
            <SlidingIndicator activeIndex={tabs.indexOf(activeTab)} />
          </TabContainer>

          <AnimatedListWrapper key={activeTab}>
            {currentStaticItems.length > 0 && currentStaticItems.map((item, index) => renderDesktopItem(item, index, 'static'))}

            {dynamicGroups.length > 0 && (
              <>
                {dynamicGroups.map((group, index) =>
                  renderDesktopItem({
                    name: group.name,
                    icon: group.icon || 'https://static.nanogames.io/assets/slots.42749df8.png',
                    path: `${dynamicGroupPrefix}${group.slug || group.id}`
                  }, index, 'group')
                )}
              </>
            )}

            <Divider isCollapsed={finalIsCollapsed} />
            {COMMON_ITEMS.map((item, index) => renderDesktopItem(item, index, 'common'))}
          </AnimatedListWrapper>

          <Divider />

          <Flex style={{ marginTop: "15px", marginBottom: "15px" }}>
            <Container>
              {/* <Title>Language Options</Title> */}
              <LanguageButton>
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  <TbWorld size={25} />

                  <ButtonText
                    isCollapsed={finalIsCollapsed}
                    className="game-fonts"
                    style={{ fontWeight: "bold" }}
                  >
                    English
                  </ButtonText>
                </div>

                <StyledChevronRight isCollapsed={finalIsCollapsed} size={24} />
              </LanguageButton>
            </Container>
          </Flex>

          <Divider />

          {settings.social_links && Array.isArray(settings.social_links) ? (
            settings.social_links
              .filter(s => s.is_enabled && s.show_in_sidebar)
              .map((s) => {
                const handleClick = () => {
                  if (s.type === 'live_chat' || s.id === 'live_support') {
                    support();
                  } else if (s.url) {
                    window.open(s.url, '_blank');
                  }
                };

                const renderIcon = () => {
                  if (s.icon_url) {
                    return <img style={{ width: "22px", height: "22px", objectFit: "contain" }} src={s.icon_url.startsWith('http') ? s.icon_url : `${API}${s.icon_url}`} alt={s.name} />;
                  }
                  const IconComp = LucideIcons[s.icon_name || 'Headphones'] || LucideIcons.Headphones;
                  return <IconComp size={20} color="white" style={{ width: "20px", height: "20px" }} />;
                };

                return (
                  <Flex key={s.id} style={{ width: '100%' }}>
                    <SupportItemButton isCollapsed={finalIsCollapsed} onClick={handleClick}>
                      <IconWrapper isCollapsed={finalIsCollapsed} style={{ marginRight: finalIsCollapsed ? '0' : '10px' }}>
                        {renderIcon()}
                      </IconWrapper>
                      {!finalIsCollapsed && (
                        <span
                          className="game-fonts"
                          style={{
                            color: "white",
                            fontSize: "13px",
                            fontWeight: "bold",
                          }}
                        >
                          {s.name}
                        </span>
                      )}
                    </SupportItemButton>
                  </Flex>
                );
              })
          ) : (
            <>
              <Flex style={{ width: '100%' }}>
                <SupportItemButton isCollapsed={finalIsCollapsed} onClick={telegramLink}>
                  <IconWrapper isCollapsed={finalIsCollapsed} style={{ marginRight: finalIsCollapsed ? '0' : '10px' }}>
                    <img style={{ width: "22px", height: "22px", objectFit: "contain" }} src="/assets/images/telegram.webp" alt="Telegram" />
                  </IconWrapper>
                  {!finalIsCollapsed && (
                    <span
                      className="game-fonts"
                      style={{
                        color: "white",
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      Telegram Support
                    </span>
                  )}
                </SupportItemButton>
              </Flex>
              <Flex style={{ width: '100%' }}>
                <SupportItemButton isCollapsed={finalIsCollapsed} onClick={support}>
                  <IconWrapper isCollapsed={finalIsCollapsed} style={{ marginRight: finalIsCollapsed ? '0' : '10px' }}>
                    <Headphones size={20} color="white" style={{ width: "20px", height: "20px" }} />
                  </IconWrapper>
                  {!finalIsCollapsed && (
                    <span
                      className="game-fonts"
                      style={{
                        color: "white",
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      Live Support
                    </span>
                  )}
                </SupportItemButton>
              </Flex>
            </>
          )}
        </SidebarContent>
      </SidebarContainer>
    </>
  );
};

export default SidebarHello;
